//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import { required } from '@/utils/validation.js';
import { cleanObj } from '~/utils';
import {
  jobTypes,
  salaryType,
  holidayType,
  workTimeType,
  specificApplicantType,
  educationLevel,
} from '~/utils/jobs';
import LanguageList from './LanguageList';

export default {
  name: 'EditJob',
  components: { LanguageList },
  props: {
    isEdit: { type: Boolean, default: false },
    jobPositionId: { type: String, default: '' },
  },
  data() {
    return {
      jobTypes,
      salaryType,
      holidayType,
      workTimeType,
      specificApplicantType,
      educationLevel,
      importData: {
        url: '',
      },
      infoData: {
        status: 1,
        type: 0,
        recruitNumber: 1,
        salaryType: 2,
        holidayType: 1,
        workTimeType: 1,
        goOutBusiness: 0,
        companyLocation: 0,
        managementPosition: 0,
        specificApplicantType: 0,
        specificMajor: 0,
        educationLevel: 0,
        languageList: [],
      },
      isImportLoading: false,
      salaryValue: null,
      salaryMin: null,
      salaryMax: null,
      salaryRange: 'between',
      seniorityValue: null,
      seniorityMin: null,
      seniorityMax: null,
      seniorityRange: 'between',
      requireSeniority: 0,
      specificApplicantList: [0],
      rules: {
        title: [required],
        status: [required],
        type: [required],
        jobCatId: [required],
        workTimeType: [required],
        holidayType: [required],
        content: [required],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['userStatus']),
    ...mapGetters('common', [
      'areaLocalTree',
      'jobCatTree',
      'skillTree',
      'majorTree',
    ]),
    editLabel() {
      return this.isEdit ? '編輯職缺' : '刊登職缺';
    },
    salary() {
      switch (this.salaryRange) {
        case 'upper':
          return [this.salaryValue, null];
        case 'lower':
          return [null, this.salaryValue];

        case 'between':
        default:
          return [this.salaryMin || null, this.salaryMax || null];
      }
    },
    seniority() {
      if (this.requireSeniority) {
        switch (this.seniorityRange) {
          case 'upper':
            return [this.seniorityValue, null];
          case 'lower':
            return [null, this.seniorityValue];

          case 'between':
          default:
            return [this.seniorityMin || null, this.seniorityMax || null];
        }
      }

      return [null, null];
    },
  },
  methods: {
    ...mapActions('common', ['getMajorTree']),
    specificApplicantChange(currentValue) {
      // 勾選不拘時 清除其他勾選
      const hasCasual = this.specificApplicantList.includes(0);
      if (hasCasual && currentValue === 0) {
        this.specificApplicantList = [0];
        this.infoData.specificApplicantType = '';
        return;
      }

      this.specificApplicantList = this.specificApplicantList.filter(
        i => i !== 0,
      );
      this.infoData.specificApplicantType =
        this.specificApplicantList.join(',');
    },
    salaryRangeChange() {
      this.salaryValue = this.salaryMin || this.salaryMax || 0;
    },
    seniorityRangeChange() {
      this.seniorityValue = this.seniorityMin || this.seniorityMax || 0;
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this));
      setTimeout(() => {
        this.$refs.infoData.clearValidate();
      }, 50);
    },
    handleGetData(data) {
      if (!data) return;

      this.infoData = { ...this.infoData, ...cleanObj(data) };

      // 薪資
      if (data.salary) {
        this.salaryMin = data.salary[0];
        this.salaryMax = data.salary[1];

        switch (true) {
          case data.salary[0] === null && data.salary[1] === null:
            this.salaryRange = 'between';
            break;
          case data.salary[0] === null:
            this.salaryRange = 'lower';
            this.salaryValue = data.salary[1];
            break;
          case data.salary[1] === null:
            this.salaryRange = 'upper';
            this.salaryValue = data.salary[0];
            break;

          default:
            this.salaryRange = 'between';
            break;
        }
      }

      // 年資
      if (data.seniority) {
        this.seniorityMin = data.seniority[0];
        this.seniorityMax = data.seniority[1];
        this.requireSeniority = data.seniority === [null, null] ? 0 : 1;

        switch (true) {
          case data.seniority[0] === null && data.seniority[1] === null:
            this.seniorityRange = 'between';
            break;
          case data.seniority[0] === null:
            this.seniorityRange = 'lower';
            this.seniorityValue = data.seniority[1];
            break;
          case data.seniority[1] === null:
            this.seniorityRange = 'upper';
            this.seniorityValue = data.seniority[0];
            break;

          default:
            this.seniorityRange = 'between';
            break;
        }
      }

      // 科系要求
      if (data.majorList) {
        this.infoData.majorIds = data.majorList.map(i => i.majorId);
      }

      // 工作技能
      if (data.skillList) {
        this.infoData.skillIds = data.skillList.map(i => i.skillThreeId);
      }

      // 接受身份 ex:'1,2' => [1,2]
      if (data.specificApplicantType) {
        this.specificApplicantList = data.specificApplicantType
          .split(',')
          .map(i => ~~i);
      }
    },
    getOwnerJob() {
      if (!this.jobPositionId) return;

      this.$api('getOwnerJob', { jobPositionId: this.jobPositionId }).then(
        data => {
          this.handleGetData(data);
        },
      );
    },
    getLanguageList() {
      // getOwnerJobLanguage
      this.$api('getOwnerJob', {
        jobPositionId: this.jobPositionId,
      }).then(data => {
        this.infoData.languageList = data.languageList;
      });
    },
    onSave() {
      let payload = cleanObj({
        ...this.infoData,
        salary: this.salary,
        seniority: this.seniority,
      });

      // 上班地點勾選同公司地址時 移除 areaDetailId location
      if (payload.companyLocation === 1) {
        payload.areaDetailId = '';
        payload.location = '';
      }

      // 移除語言要求未填語言名稱
      payload.languageList = payload.languageList.filter(
        i => !!i.languageName.trim(),
      );

      if (this.isEdit) {
        payload.jobPositionId = this.jobPositionId;

        // 更新時 語言要求用另一api打
        delete payload.languageList;
        delete payload.skillList;
      }

      this.$refs.infoData.validate(valid => {
        if (!valid) {
          return false;
        }

        this.$api(this.isEdit ? 'updateOwnerJob' : 'addOwnerJob', payload)
          .then(data => {
            this.$message.success(`${this.editLabel}成功!`);
            // 編輯後:重撈資料 新增後:跳至職缺管理
            if (this.isEdit) {
              this.getOwnerJob();
            } else {
              this.resetData();
              this.$router.push(
                '/Owner/Manage?tab=jobsManagement&subTab=jobsManagement',
              );
            }
          })
          .catch(error => {
            this.$message.warning(`${this.editLabel}失敗!`);
          });
      });
    },
    onImport() {
      if (!this.importData.url.includes('www.104.com.tw/job')) {
        return this.$message.warning(`請輸入104職缺網址!`);
      }

      this.isImportLoading = true;

      let payload = cleanObj({
        ...this.importData,
      });

      this.$api('parserOwnerJob', payload)
        .then(data => {
          this.$message.success(`導入職缺資料成功!`);
          this.handleGetData(data);
          this.isImportLoading = false;
        })
        .catch(error => {
          this.$message.warning(`導入職缺資料失敗!`);
          this.isImportLoading = false;
        });
    },
  },
  mounted() {
    this.getMajorTree();
    if (this.isEdit) this.getOwnerJob();
  },
};
